import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138ad326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container no-padding" }
const _hoisted_2 = { class: "row no-margin" }
const _hoisted_3 = { class: "col-md-12 row flex-container" }
const _hoisted_4 = { class: "text-container" }
const _hoisted_5 = { class: "big-text" }
const _hoisted_6 = { class: "small-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_errorhandler = _resolveComponent("errorhandler")!
  const _component_AppBarLayout = _resolveComponent("AppBarLayout")!

  return (_openBlock(), _createBlock(_component_AppBarLayout, null, {
    default: _withCtx(({}) => [
      _createElementVNode("div", {
        class: "landing-page overflow-x-hide",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "col-md-12",
              style: _normalizeStyle({ 'min-height': _ctx.dyn_height })
            }, [
              _createElementVNode("div", {
                class: "row no-padding main-body h-100",
                style: _normalizeStyle({ height: _ctx.windowHeight })
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_brandpattern, { page: "LANDING" }),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getUiText("user-temp-holding-heading-1")), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getUiText("user-temp-holding-heading-sub-1")), 1)
                  ])
                ])
              ], 4)
            ], 4),
            (_ctx.showProspectCallbackError || null)
              ? (_openBlock(), _createBlock(_component_errorhandler, {
                  key: 0,
                  "prospect-callback-error-msg": _ctx.prospectCallbackErrorMsg
                }, null, 8, ["prospect-callback-error-msg"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}